import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { GenerateSaleExportContext } from '@/lib/contexts/generate-sale-export.context';
import { DatasourceInstructionMode } from '@/lib/graphql/generated/graphql';
import { getInstructionModeLabel } from '@/lib/utils/instruction-mode-mapper';

interface OptionReminderProps {
  instructionMode: DatasourceInstructionMode;
  onModify: () => void;
}

export function OptionReminder({
  instructionMode,
  onModify,
}: OptionReminderProps) {
  const { t } = useTranslation();
  const generateSaleExport = useContext(GenerateSaleExportContext);

  if (generateSaleExport) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
      <span className="text-sm text-gray-700">
        {t('components.import_flow.products_option_selection.option_chosen')} :{' '}
        <span className="font-medium">
          {getInstructionModeLabel(instructionMode, t)}
        </span>
      </span>
      <Button
        variant="link"
        className="h-auto p-0 text-sm sm:ml-2"
        onClick={onModify}
      >
        {t('general.modify')}
      </Button>
    </div>
  );
}
